import { Icon, IconProps } from "@chakra-ui/react";

export const DocumentBgIcon = () => {
  return (
    <svg
      width="80"
      height="98"
      viewBox="0 0 80 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M79.0978 27.627L52.2049 0.897121C51.6269 0.322711 50.8434 0 50.0261 0L9.86402 0C4.42496 0 0 4.39813 0 9.80421L0 88.1958C0 93.6019 4.42496 98 9.86402 98H70.136C75.575 98 80 93.6019 80 88.1958V29.7924C80.0002 28.9802 79.6755 28.2012 79.0978 27.627ZM53.1072 10.4561L69.4803 26.7301H53.1072V10.4561ZM70.1362 91.875H9.86402C7.82293 91.875 6.16236 90.2245 6.16236 88.1958L6.16236 9.80421C6.16236 7.7755 7.82293 6.125 9.86402 6.125L46.9449 6.125V29.7924C46.9449 31.4836 48.3245 32.8549 50.0261 32.8549L73.8378 32.8549V88.1956C73.8378 90.2245 72.1773 91.875 70.1362 91.875Z"
        fill="white"
        fillOpacity="0.1"
      />
    </svg>
  );
};

export const PhoneBgIcon = () => {
  return (
    <svg
      width="55"
      height="99"
      viewBox="0 0 55 99"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.6644 1H11.3346C5.62907 1.00643 1.00565 5.62194 1 11.3177V87.6832C1.00565 93.3789 5.62907 97.9943 11.3346 98H43.6644C49.3699 97.9943 53.9935 93.3789 54 87.6832V11.3177C53.9935 5.62194 49.3699 1.00643 43.6644 1ZM49.5825 87.6832C49.5797 90.9445 46.9317 93.5879 43.6644 93.5912H11.3346C8.06737 93.5879 5.41962 90.9445 5.41639 87.6832V11.3177C5.41962 8.05524 8.06737 5.41206 11.3346 5.40883H43.6644C46.9317 5.41206 49.5797 8.05524 49.5825 11.3177V87.6832Z"
        fill="white"
        fillOpacity="0.1"
        stroke="white"
        strokeOpacity="0.1"
        strokeWidth="0.3"
      />
      <path
        d="M34.1256 9.81836H20.8756C19.656 9.81836 18.667 10.8049 18.667 12.0223C18.667 13.2398 19.656 14.2272 20.8756 14.2272H34.1256C35.3453 14.2272 36.3335 13.2398 36.3335 12.0223C36.3335 10.8049 35.3453 9.81836 34.1256 9.81836Z"
        fill="white"
        fillOpacity="0.1"
        stroke="white"
        strokeOpacity="0.1"
        strokeWidth="0.3"
      />
      <path
        d="M31.9186 84.7721C31.9186 87.2079 29.9412 89.1817 27.5022 89.1817C25.0623 89.1817 23.085 87.2079 23.085 84.7721C23.085 82.337 25.0623 80.3633 27.5022 80.3633C29.9412 80.3633 31.9186 82.337 31.9186 84.7721Z"
        fill="white"
        fillOpacity="0.1"
        stroke="white"
        strokeOpacity="0.1"
        strokeWidth="0.3"
      />
    </svg>
  );
};

export const TalkBallonBgIcon = () => {
  return (
    <svg
      width="89"
      height="87"
      viewBox="0 0 89 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M73.3425 59.1665L73.7307 54.9094V50.7921C75.0787 50.2283 76.8747 49.4069 77.9043 48.3701C78.934 47.3332 79.7494 46.1037 80.3039 44.7517C80.8584 43.3998 81.1412 41.9519 81.1361 40.4906V18.468C81.1259 15.5303 79.9544 12.7158 77.8771 10.6385C75.7998 8.5612 72.9853 7.38967 70.0475 7.37949H33.1887C30.251 7.38967 27.4365 8.5612 25.3592 10.6385C24.1877 11.81 23.3043 13.2159 22.7548 14.7461H18.6266L15.0386 15.0574C15.7206 11.4278 17.4813 8.05767 20.1298 5.40917C23.5933 1.94574 28.2907 0 33.1887 0H70.0475C74.9389 0.0102329 79.6263 1.96048 83.0814 5.42281C86.5365 8.88513 88.4769 13.5767 88.4769 18.468V40.4906C88.482 42.9159 88.0094 45.3184 87.0859 47.561C86.1625 49.8036 84.8064 51.8423 83.0951 53.5608C81.3838 55.2793 79.3507 56.6439 77.112 57.5767C74.8733 58.5095 73.3425 59.1665 73.3425 59.1665Z"
        fill="white"
        fillOpacity="0.1"
      />
      <path
        d="M36.8588 86.3517L24.2635 73.7563H18.4294C13.5448 73.7461 8.8631 71.8012 5.40912 68.3472C1.95515 64.8932 0.0102083 60.2116 0 55.3269V33.1884C0.0102083 28.3038 1.95515 23.6221 5.40912 20.1682C8.8631 16.7142 13.5448 14.7692 18.4294 14.759H55.2882C60.1796 14.759 64.8711 16.6995 68.3335 20.1545C71.7958 23.6096 73.746 28.2971 73.7563 33.1884V55.3269C73.746 60.2182 71.7958 64.9057 68.3335 68.3608C64.8711 71.8159 60.1796 73.7563 55.2882 73.7563H49.4542L36.8588 86.3517ZM18.4294 22.1385C15.4952 22.1385 12.6806 23.3015 10.6022 25.3726C8.52384 27.4438 7.35108 30.2543 7.34085 33.1884V55.3269C7.35104 58.2646 8.52256 61.0791 10.5999 63.1565C12.6772 65.2338 15.4917 66.4053 18.4294 66.4155H27.3157L36.8588 75.9199L46.4019 66.4155H55.2882C58.226 66.4053 61.0405 65.2338 63.1178 63.1565C65.1951 61.0791 66.3666 58.2646 66.3768 55.3269V33.1884C66.3665 30.2543 65.1938 27.4438 63.1154 25.3726C61.037 23.3015 58.2224 22.1385 55.2882 22.1385H18.4294Z"
        fill="white"
        fillOpacity="0.1"
      />
      <path
        d="M18.4297 40.5676H25.8092V47.9471H18.4297V40.5676Z"
        fill="white"
        fillOpacity="0.1"
      />
      <path
        d="M33.1885 40.5676H40.568V47.9471H33.1885V40.5676Z"
        fill="white"
        fillOpacity="0.1"
      />
      <path
        d="M47.9121 40.5676H55.2916V47.9471H47.9121V40.5676Z"
        fill="white"
        fillOpacity="0.1"
      />
    </svg>
  );
};

export const CardBgIcon = () => {
  return (
    <svg
      width="94"
      height="71"
      viewBox="0 0 94 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M88.125 0H5.87502C4.31685 0 2.82254 0.623391 1.72077 1.73297C0.619001 2.84255 0 4.34747 0 5.91665V65.0834C0 66.6526 0.619001 68.1576 1.72077 69.267C2.82254 70.3764 4.31685 71 5.87502 71H88.125C89.6828 71 91.1772 70.3764 92.2792 69.267C93.3808 68.1576 94 66.6526 94 65.0834V5.91665C94 4.34747 93.3808 2.84255 92.2792 1.73297C91.1772 0.623391 89.6828 0 88.125 0ZM88.125 5.91665V41.4165H5.87502V5.91665H88.125ZM5.87502 65.0834V53.2498H88.125V65.0834H5.87502Z"
        fill="white"
        fillOpacity="0.1"
      />
    </svg>
  );
};

export const BankBgIcon = () => {
  return (
    <svg
      width="98"
      height="91"
      viewBox="0 0 98 91"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M83.8143 37.8972H65.2461Z" fill="white" fillOpacity="0.1" />
      <path d="M83.8143 76.9421H65.2461Z" fill="white" fillOpacity="0.1" />
      <path d="M69.8895 37.8972V76.9426Z" fill="white" fillOpacity="0.1" />
      <path d="M79.1725 37.8972V76.9426Z" fill="white" fillOpacity="0.1" />
      <path d="M58.2833 37.8972H39.7151Z" fill="white" fillOpacity="0.1" />
      <path d="M58.2833 76.9421H39.7151Z" fill="white" fillOpacity="0.1" />
      <path d="M44.3585 37.8972V76.9426Z" fill="white" fillOpacity="0.1" />
      <path d="M53.6415 37.8972V76.9426Z" fill="white" fillOpacity="0.1" />
      <path d="M32.7539 37.8972H14.186Z" fill="white" fillOpacity="0.1" />
      <path d="M32.7539 76.9421H14.186Z" fill="white" fillOpacity="0.1" />
      <path d="M18.8275 37.8972V76.9426Z" fill="white" fillOpacity="0.1" />
      <path d="M28.1105 37.8972V76.9426Z" fill="white" fillOpacity="0.1" />
      <path
        d="M83.8143 37.8972H65.2461M83.8143 76.9421H65.2461M69.8895 37.8972V76.9426M79.1725 37.8972V76.9426M58.2833 37.8972H39.7151M58.2833 76.9421H39.7151M44.3585 37.8972V76.9426M53.6415 37.8972V76.9426M32.7539 37.8972H14.186M32.7539 76.9421H14.186M18.8275 37.8972V76.9426M28.1105 37.8972V76.9426"
        stroke="white"
        strokeOpacity="0.1"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.5803 0L94.2593 32.155H4.90137L49.5803 0ZM48.9356 27.809C49.1408 28.0264 49.4048 28.135 49.7275 28.135C50.0503 28.135 50.3143 28.0264 50.5199 27.809C50.7251 27.6061 50.8277 27.3525 50.8277 27.0482V25.4959C51.6377 25.3751 52.3565 25.1535 52.9839 24.8311C53.7319 24.4399 54.3186 23.9255 54.744 23.2879C55.1693 22.6358 55.382 21.8895 55.382 21.0491C55.382 19.9767 55.0522 19.1145 54.3923 18.4625C53.7319 17.7959 52.6979 17.3105 51.2899 17.0061L48.8917 16.4845C48.1143 16.3106 47.564 16.0787 47.2412 15.7889C46.9189 15.4846 46.7575 15.0861 46.7575 14.5934C46.7575 13.9269 47.0215 13.3907 47.5495 12.985C48.0923 12.5647 48.833 12.3546 49.7718 12.3546C50.505 12.3546 51.136 12.4343 51.6639 12.5937C52.1919 12.7386 52.6686 12.9342 53.0939 13.1806C53.4022 13.3545 53.6736 13.4342 53.9082 13.4197C54.1573 13.3907 54.3629 13.3038 54.5243 13.1588C54.6856 13.014 54.7953 12.84 54.8541 12.6372C54.9128 12.4198 54.9054 12.2025 54.8321 11.9851C54.7589 11.7532 54.612 11.5504 54.3923 11.3765C53.8494 10.9562 53.1965 10.6302 52.434 10.3984C51.8646 10.2219 51.3292 10.1084 50.8277 10.0578V8.5508C50.8277 8.24651 50.7177 7.99291 50.4976 7.79005C50.2923 7.57266 50.0358 7.46398 49.7275 7.46398C49.4048 7.46398 49.1408 7.57266 48.9356 7.79005C48.7303 7.99291 48.6277 8.24651 48.6277 8.5508V10.0928C47.7831 10.1961 47.0351 10.4212 46.3835 10.7679C45.6205 11.1736 45.0264 11.717 44.601 12.3981C44.1757 13.0647 43.963 13.8254 43.963 14.6804C43.963 15.7817 44.2932 16.6728 44.9531 17.3539C45.6131 18.035 46.6107 18.5204 47.9455 18.8102L50.2778 19.3102C50.8497 19.4261 51.3044 19.5782 51.642 19.7666C51.9792 19.9405 52.2213 20.1506 52.3678 20.397C52.5146 20.6288 52.5879 20.9042 52.5879 21.2229C52.5879 21.6142 52.4778 21.962 52.2581 22.2663C52.0525 22.5706 51.7227 22.8097 51.268 22.9836C50.8132 23.1574 50.2191 23.2444 49.4855 23.2444C48.5471 23.2444 47.7402 23.143 47.0654 22.9401C46.4054 22.7227 45.87 22.4981 45.4592 22.2663C45.1513 22.0924 44.8799 22.0344 44.6453 22.0924C44.4103 22.1359 44.2125 22.2518 44.0511 22.4402C43.9042 22.614 43.8165 22.8242 43.7871 23.0705C43.7577 23.3169 43.7946 23.5632 43.8972 23.8095C43.9998 24.0414 44.1831 24.237 44.4471 24.3964C44.9899 24.7007 45.6499 24.9688 46.4274 25.2007C47.0849 25.3932 47.8183 25.5157 48.6277 25.5684V27.0482C48.6277 27.3525 48.7303 27.6061 48.9356 27.809Z"
        fill="white"
        fillOpacity="0.1"
      />
      <path d="M90.7782 82.6848H7.22286Z" fill="white" fillOpacity="0.1" />
      <path d="M96 89.0001H2Z" fill="white" fillOpacity="0.1" />
      <path
        d="M90.7782 82.6848H7.22286M96 89.0001H2"
        stroke="white"
        strokeOpacity="0.1"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WhatsAppBgIcon = () => {
  return (
    <svg
      width="95px"
      height="95px"
      viewBox="0 0 98 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M83.7186 15.2451C79.2037 10.684 73.8259 7.06757 67.8989 4.60683C61.9719 2.1461 55.6143 0.890288 49.197 0.912647C22.3085 0.912647 0.393971 22.83 0.393971 49.7218C0.393971 58.341 2.6593 66.7139 6.89447 74.1018L0 99.4176L25.8543 92.6207C32.995 96.5117 41.0221 98.5803 49.197 98.5803C76.0854 98.5803 98 76.6629 98 49.7711C98 36.7192 92.9276 24.4553 83.7186 15.2451ZM49.197 90.3059C41.9085 90.3059 34.7678 88.3358 28.5136 84.6418L27.0362 83.7553L11.6714 87.794L15.7588 72.8213L14.7739 71.2944C10.7246 64.8274 8.57446 57.3522 8.56884 49.7218C8.56884 27.3612 26.7899 9.13781 49.1477 9.13781C59.9819 9.13781 70.1759 13.3735 77.809 21.0569C81.5886 24.8196 84.5838 29.2952 86.6211 34.2242C88.6584 39.1532 89.6972 44.4376 89.6774 49.7711C89.7759 72.1317 71.5548 90.3059 49.197 90.3059ZM71.4563 59.9664C70.2251 59.3753 64.2171 56.4202 63.1337 55.9769C62.001 55.5829 61.2131 55.3859 60.3759 56.5679C59.5387 57.7992 57.2241 60.5574 56.5347 61.3454C55.8452 62.1827 55.1065 62.2812 53.8754 61.6409C52.6442 61.0499 48.7045 59.7201 44.0754 55.5829C40.4311 52.3322 38.0181 48.3428 37.2794 47.1115C36.5899 45.8801 37.1809 45.2399 37.8211 44.5996C38.3628 44.0578 39.0523 43.1713 39.6432 42.4817C40.2342 41.7922 40.4804 41.2504 40.8744 40.4624C41.2683 39.6251 41.0714 38.9356 40.7759 38.3445C40.4804 37.7535 38.0181 31.7447 37.0332 29.2821C36.0482 26.918 35.0141 27.2135 34.2754 27.1642H31.9116C31.0744 27.1642 29.794 27.4597 28.6613 28.691C27.5779 29.9223 24.4261 32.8775 24.4261 38.8863C24.4261 44.8951 28.809 50.7069 29.4 51.4949C29.991 52.3322 38.0181 64.6453 50.2311 69.9154C53.1367 71.1959 55.402 71.9347 57.1749 72.4765C60.0804 73.4123 62.7397 73.2645 64.8573 72.969C67.2211 72.6242 72.0965 70.0139 73.0814 67.1572C74.1156 64.3006 74.1156 61.8872 73.7709 61.3454C73.4261 60.8036 72.6874 60.5574 71.4563 59.9664Z"
        fill="white"
        fillOpacity="0.1"
      />
    </svg>
  );
};

export function FGTSIcon({ ...rest }: IconProps) {
  return (
    <Icon
      width="160px"
      height="95px"
      viewBox="0 0 450 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M0.785156 52.243V0.195312H52.8328H104.849L104.756 6.80996C104.663 12.9588 104.601 13.4867 103.949 14.8531C102.52 17.7412 100.067 19.6355 96.4957 20.5361C94.8809 20.9709 94.8498 20.9709 96.1231 20.8467C96.8684 20.7535 98.1416 20.3809 98.8869 20.0393L100.315 19.4182L99.4459 20.3188C98.8248 20.9709 98.1106 21.3125 96.9615 21.4988C96.0609 21.6541 78.8256 21.7473 58.64 21.6852C24.2004 21.623 21.9334 21.5609 21.8092 21.0641C21.716 20.7846 21.6539 37.0883 21.6539 57.3359C21.6539 77.5836 21.716 93.8873 21.8092 93.5768C21.8713 93.2973 22.0887 93.1109 22.2439 93.2041C22.5855 93.4525 22.6166 95.5332 22.275 95.5332C22.1197 95.5332 22.0576 95.9369 22.1508 96.4338C22.2439 97.0859 22.0266 97.5828 21.3123 98.3592L20.3807 99.415L20.9707 97.7691C21.3123 96.8686 21.5918 95.7506 21.5607 95.2848C21.5297 94.6947 21.4365 94.8189 21.2502 95.8127C20.598 99.0734 18.4553 101.837 15.4119 103.266C13.735 104.042 13.4555 104.073 7.24453 104.166L0.785156 104.26V52.243Z"
        fill="white"
        fillOpacity="0.15"
      />
      <path
        d="M122.923 103.794C120.128 102.893 117.737 100.75 116.464 97.9865L115.688 96.2475L115.75 51.8703L115.843 7.49316L116.588 5.94043C117.582 3.98398 119.476 2.08965 121.433 1.0959L122.985 0.350586L171.369 0.257422L219.783 0.195312L219.659 6.49941L219.565 12.7725L218.541 14.8531C217.423 17.1201 215.87 18.6729 213.541 19.8219L212.112 20.5361L174.163 20.6293L136.184 20.6914V52.2119V83.7324H167.549H198.914V73.1738V62.6152H183.635C175.219 62.6152 167.456 62.491 166.369 62.3357C162.673 61.7768 159.816 59.6961 158.295 56.4664C157.487 54.7584 157.456 54.4789 157.363 48.2369L157.27 41.8086L184.536 41.8707L211.802 41.9639L213.541 42.7713C215.777 43.8272 217.702 45.7525 218.758 47.9885L219.565 49.7275V73.0186V96.3096L218.851 97.8313C217.702 100.316 216.212 101.93 213.882 103.048L211.802 104.073L168.015 104.135C132.612 104.166 123.979 104.104 122.923 103.794Z"
        fill="white"
        fillOpacity="0.15"
      />
      <path
        d="M271.893 62.491V20.7225L254.906 20.6293L237.888 20.5361L236.118 19.6666C233.913 18.5797 231.77 16.2506 230.931 13.9836C230.341 12.493 230.279 11.5613 230.279 6.25098V0.195312H282.327H334.344L334.25 6.65469C334.157 12.9588 334.126 13.1141 333.288 14.8221C332.294 16.8717 330.213 18.9213 328.164 19.8529C326.735 20.5361 326.363 20.5361 309.717 20.6293L292.699 20.7225V57.3049C292.699 80.7512 292.575 94.4773 292.389 95.5643C291.705 99.0424 289.625 101.806 286.55 103.235C284.842 104.042 284.563 104.073 278.352 104.166L271.893 104.26V62.491Z"
        fill="white"
        fillOpacity="0.15"
      />
      <path
        d="M344.871 98.7008C344.871 92.7072 345.213 90.5334 346.548 88.4527C347.449 87.0242 349.126 85.5336 350.865 84.602L352.169 83.8877L390.304 83.7945L428.408 83.7324V73.1738V62.6463L390.77 62.5531L353.101 62.46L351.144 61.5594C348.691 60.4104 346.393 58.0191 345.585 55.7211C345.057 54.1684 345.026 52.5846 345.026 31.0947V8.11426L346.051 6.03359C347.262 3.54922 349.219 1.71699 351.579 0.816406C353.256 0.195312 353.784 0.195312 401.235 0.195312H449.215V4.94668C449.215 7.52422 449.091 10.5365 448.935 11.6234C448.376 15.2879 446.513 17.9586 443.252 19.6666L441.606 20.5361L403.658 20.6293L365.678 20.6914V31.25V41.8086L403.502 41.8707L441.296 41.9639L443.066 42.8334C445.209 43.8893 447.693 46.4979 448.47 48.5475C448.997 49.9449 449.06 51.5908 449.153 71.6211C449.246 93.8873 449.153 96.0301 448.004 98.4523C447.103 100.285 444.991 102.303 443.004 103.266L441.296 104.073L393.099 104.166L344.871 104.229V98.7008Z"
        fill="white"
        fillOpacity="0.15"
      />
      <path
        d="M21.0636 97.707L21.7468 95.999L21.84 58.3297L21.9331 20.6603L59.6335 20.6914C97.2408 20.7224 97.365 20.7224 98.8246 20.0703C100.16 19.5113 99.1662 20.5672 90.1913 29.573L80.0365 39.6968L77.9247 37.9578C72.5523 33.517 64.3538 30.8773 58.1119 31.5605C46.0626 32.9269 36.2183 41.467 33.0197 53.3299C32.1191 56.7148 32.057 62.3668 32.8954 65.4101C34.2619 70.441 36.2183 74.2297 39.1374 77.7078L40.5038 79.2916L30.4111 89.3533C20.6288 99.1355 20.3804 99.3529 21.0636 97.707Z"
        fill="white"
        fillOpacity="0.05"
      />
      <path
        d="M38.1131 78.5461C35.225 75.0679 33.3307 71.3103 31.9643 66.3416C31.0947 63.174 31.1568 55.8451 32.0885 52.398C36.4982 36.1875 53.1746 26.84 68.8572 31.7467C72.3664 32.8646 76.3414 34.9453 78.8568 37.026L80.9686 38.765L60.3793 59.3853C49.0443 70.7203 39.6658 80.0056 39.5416 80.0056C39.4484 80.0056 38.7963 79.3535 38.1131 78.5461Z"
        fill="white"
        fillOpacity="0.1"
      />
    </Icon>
  );
}
